import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import Svg from '@justgiving/svg';
import chevron from '@justgiving/icons/src/chevron-left-slim.svg';
import { paths } from 'constants';

const svg = (
  <Svg
    markup={chevron}
    className="jg-icon--slim jg-fill--dark-orchid jg-pull-left"
  />
);

const SettingsLink = ({ path, label, classNames }) => (
  <Link to={path} className={`jg-clearfix nav__settings-link ${classNames}`}>
    {svg}
    <div className="jg-pull-left jg-space-plxs qa-nav__settings-link">
      {label}
    </div>
  </Link>
);

SettingsLink.propTypes = {
  path: PropTypes.string,
  label: PropTypes.string,
  classNames: PropTypes.string,
};

SettingsLink.defaultProps = {
  path: paths.Index,
  label: 'Account & preferences',
  classNames: '',
};

export default SettingsLink;
